import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3c150a85")

_pushScopeId("data-v-3c150a85")
const _hoisted_1 = { class: "well" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { "data-cy": "PayPortal.RedemptionCode.Heading" }, "You have chosen to use a redemption code.", -1)
const _hoisted_3 = { "data-cy": "PayPortal.DeferPayment.Expiry" }
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { "data-cy": "PayPortal.RedemptionCode.Instructions" }, [
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode("A redemption code is a 16-character alphanumeric code that gives you access to Möbius. "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode("Not sure where to get one? "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode("Please reach out to your instructor or textbook provider for further instructions. ")
], -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createVNode("h2", null, "Working on it...", -1)
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "form-horizontal narrower" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = /*#__PURE__*/_createVNode("p", { "data-cy": "PayPortal.RedemptionCode.RedemptionCodeInputBoxLabel" }, "Please enter your redemption code:", -1)
const _hoisted_11 = { id: "redemptionCode" }
const _hoisted_12 = {
  key: 0,
  class: "error"
}
const _hoisted_13 = {
  style: {"white-space":"pre-line"},
  "data-cy": "PayPortal.RedemptionCode.ErrorMessage"
}
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode("We'll send you an email to the following address with the expiry date details.")
], -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("p", null, "You can use a different email address.", -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("label", {
  for: "emailAddress",
  class: "col-sm-2 control-label"
}, "Email", -1)
const _hoisted_18 = { class: "col-sm-10" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = { id: "buttons" }
_popScopeId()

import { Backend, ContentAndStudent, Failure, EmailValues, RedemptionCodeOption } from '@/modules/backend';
import { onMounted, ref} from 'vue';
import { prettyDate } from '@/modules/frontend';
import InputMask from "primevue/inputmask";


export default _defineComponent({
  expose: [],
  props: {
    redemptionCodeOption: { type: null, required: true },
    contentAndStudent: { type: null, required: true },
    emailValues: { type: null, required: true }
  } as unknown as undefined,
  emits: ['other-options', 'success', 'error'],
  setup(__props: {
	redemptionCodeOption: RedemptionCodeOption
	contentAndStudent: ContentAndStudent
	emailValues: EmailValues
}, { emit }) {

const props = __props






let waitingForBackend = ref(false)
let emailValues = ref({ ...props.emailValues })


const redemptionCode = ref("")
const errorMsgVisible = ref(false)
const errorMsg = ref("")


onMounted(async () => {
	focusOnRedemptionCodeBox()	
	const queryParam = new URLSearchParams(window.location.search).get('redemption_code') // Replace 'queryParam' with the actual parameter name
	if (queryParam) {
		// Handle the query parameter here
		redemptionCode.value = queryParam
		processRedemptionCode()
	}

})

function focusOnRedemptionCodeBox() {
	if (document.getElementById("redemptionCodeInputBox")) {
		document.getElementById("redemptionCodeInputBox")?.focus()
	}
		
}

function showErrorMsg(msg: string) {
	errorMsg.value = msg
	waitingForBackend.value = false
	errorMsgVisible.value = true
	focusOnRedemptionCodeBox()
}

function clearRedemptionCodeInput() {
	redemptionCode.value = ""
}

async function processRedemptionCode() {

	try {
		
		if (redemptionCode.value.length < 16) {
			showErrorMsg("Please ensure that you have entered 16 alphanumeric characters.")
		} else {
			waitingForBackend.value = true
			const result = await Backend.redeemCode(props.contentAndStudent, redemptionCode.value, emailValues.value)

			if (result instanceof Failure) {

				if (result.err == "RedemptionCodeDoesNotExistForTenant") {
					showErrorMsg("Sorry! Your code is invalid.\n Please try again or contact your school if the problem persists.")
				} else if (result.err == "RedemptionCodeHasAlreadyBeenRedeemed") {
					showErrorMsg("Sorry! Your code has already been used, and can’t be used again.")
				}

			} else {
				emit('success')
			}
		}

	} catch (e: unknown) {
		console.error("Call to backend.redeemCode failed: " + e)
		emit('error')
	}
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode("p", _hoisted_3, "Upon successful redemption, we'll give you a license which will expire on " + _toDisplayString(_unref(prettyDate)(__props.redemptionCodeOption.expiry)) + ".", 1),
      _hoisted_4
    ]),
    (_unref(waitingForBackend))
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          _hoisted_6
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode("div", _hoisted_11, [
                _createVNode(_unref(InputMask), {
                  id: "redemptionCodeInputBox",
                  type: "text",
                  class: "redemptionCodeInputBox",
                  modelValue: redemptionCode.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (redemptionCode.value = $event)),
                  mask: "****-****-****-****",
                  placeholder: "____-____-____-____",
                  "auto-clear": false,
                  unmask: true,
                  onPaste: clearRedemptionCodeInput,
                  "data-cy": "PayPortal.RedemptionCode.RedemptionCodeInputBox"
                }, null, 8, ["modelValue"])
              ])
            ]),
            (errorMsgVisible.value)
              ? (_openBlock(), _createBlock("div", _hoisted_12, [
                  _createVNode("p", _hoisted_13, _toDisplayString(errorMsg.value), 1)
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_14, [
              _hoisted_15,
              _hoisted_16,
              _hoisted_17,
              _createVNode("div", _hoisted_18, [
                _withDirectives(_createVNode("input", {
                  class: "form-control",
                  id: "emailAddress",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_unref(emailValues).studentEmailAddress = $event)),
                  "data-cy": "PayPortal.RedemptionCode.EmailAddressInput"
                }, null, 512), [
                  [_vModelText, _unref(emailValues).studentEmailAddress]
                ])
              ])
            ]),
            _createVNode("div", _hoisted_19, [
              _createVNode("div", _hoisted_20, [
                _createVNode("button", {
                  type: "button",
                  class: "btn btn-lg btn-default",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('other-options'))),
                  "data-cy": "PayPortal.RedemptionCode.OtherOptionsButton"
                }, "Other options"),
                _createVNode("button", {
                  type: "button",
                  class: "btn btn-lg btn-primary",
                  onClick: processRedemptionCode,
                  "data-cy": "PayPortal.RedemptionCode.RedeemCodeButton"
                }, "Redeem code")
              ])
            ])
          ])
        ]))
  ], 64))
}
}

})